import React from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

interface IProps {
  crop: any
  setCrop: any
  onCropComplete: any
  aspect: any
  imageRef: any
  src: any
  onImageLoad: any
  croppedImageUrl: any
  closeModal: () => void
  setLoader: any
  onCropBtnClick: any
}

const CropModal: React.FC<IProps> = ({
  crop,
  setCrop,
  onCropComplete,
  aspect,
  imageRef,
  src,
  onImageLoad,
  croppedImageUrl,
  closeModal,
  setLoader,
  onCropBtnClick
}) => {
  return (
    <div className='card scroll-y pb-10 w-550px h-550px'>
      <div className='d-flex flex-column align-items-start justify-content-start mx-0 px-0 mb-2'>
        {!!src && (
          <ReactCrop
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={onCropComplete}
            aspect={aspect}
            style={{ marginBottom: '20px' }}
          >
            <img
              ref={imageRef}
              alt='Crop me'
              src={src}
              onLoad={onImageLoad}
              style={{ width: 'fit-content', height: 'fit-content' }}
            />
          </ReactCrop>
        )}
      </div>
      {!!croppedImageUrl && (
        <div className='d-flex flex-column align-items-center mt-4'>
          <h2>Image Preview</h2>
          <div
            style={{
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              overflow: 'hidden'
            }}
          >
            <img
              src={croppedImageUrl}
              alt='Cropped Image'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%'
              }}
            />
          </div>
        </div>
      )}
      <div className='d-flex justify-content-end' style={{ marginTop: '30px' }}>
        <button type='reset' className='btn btn-sm btn-primary me-4 mx-5' onClick={onCropBtnClick}>
          Upload
        </button>
        <button
          type='reset'
          className='btn btn-sm btn-danger me-2'
          onClick={() => {
            closeModal()
            setLoader(false)
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default CropModal
